(function() {
  function initDynamicSelect(root) {
    const header = root.querySelector('.dynamic-select-header');
    const headerTextEl = header ? header.querySelector('.dynamic-select-option-text') : null;
    const optionsEl = root.querySelector('.dynamic-select-options');
    const hiddenInput = root.querySelector('input[type="hidden"]');

    if (!header || !headerTextEl || !optionsEl || !hiddenInput) return;

    function applyFromOption(opt) {
      if (!opt) return;

      const value = opt.dataset.value || '';
      const label = opt.dataset.label || value || '';

      // 🔧 SPEZIALFALL: Farbauswahl
      if (root.classList.contains('dynamic-select-color')) {
        // data-label → value
        hiddenInput.value = label;
        // data-value → color-value
        hiddenInput.setAttribute('color-value', value);
      } else {
        // Standardverhalten
        hiddenInput.value = value;
        hiddenInput.removeAttribute('color-value');
      }

      // Text im Header
      headerTextEl.textContent = label;

      // Farben setzen (für Color-Select)
      if (opt.dataset.value && opt.dataset.textColor && root.classList.contains('dynamic-select-color')) {
        headerTextEl.style.backgroundColor = opt.dataset.value;
        headerTextEl.style.color = opt.dataset.textColor;
      } else if (!root.classList.contains('dynamic-select-color')) {
        headerTextEl.style.backgroundColor = '';
        headerTextEl.style.color = '';
      }

      optionsEl.querySelectorAll('.dynamic-select-option').forEach(function(o) {
        o.classList.remove('dynamic-select-selected');
      });
      opt.classList.add('dynamic-select-selected');

      const ev = new Event('change', { bubbles: true });
      hiddenInput.dispatchEvent(ev);
    }

    let activeOpt = null;
    const currentVal = (hiddenInput.value || '').toString();

    // 🔧 Initiale Auswahl: bei Farblisten nach label matchen, sonst nach value
    optionsEl.querySelectorAll('.dynamic-select-option').forEach(function(opt) {
      const compareVal = root.classList.contains('dynamic-select-color')
        ? (opt.dataset.label || '')
        : (opt.dataset.value || '');
      if (!activeOpt && compareVal === currentVal) {
        activeOpt = opt;
      }
    });

    if (!activeOpt) {
      activeOpt = optionsEl.querySelector('.dynamic-select-option');
    }

    if (activeOpt) {
      applyFromOption(activeOpt);
    }

    // Toggle öffnen/schliessen
    header.addEventListener('click', function(e) {
      e.stopPropagation();

      document.querySelectorAll('.dynamic-select.is-open').forEach(function(other) {
        if (other !== root) {
          other.classList.remove('is-open');
        }
      });

      root.classList.toggle('is-open');
    });

    optionsEl.querySelectorAll('.dynamic-select-option').forEach(function(opt) {
      opt.addEventListener('click', function(e) {
        e.stopPropagation();
        applyFromOption(opt);
        root.classList.remove('is-open');
      });
    });

    document.addEventListener('click', function(e) {
      if (!root.contains(e.target)) {
        root.classList.remove('is-open');
      }
    });
  }

  function initAllDynamicSelects(scope) {
    (scope || document).querySelectorAll('.dynamic-select').forEach(function(root) {
      if (root.dataset.dsInitialized === '1') return;
      root.dataset.dsInitialized = '1';
      initDynamicSelect(root);
    });
  }

  window.initAllDynamicSelects = initAllDynamicSelects;

  document.addEventListener('DOMContentLoaded', function() {
    initAllDynamicSelects(document);
  });
})();
